import Icon from '@ant-design/icons'
import React, { FC, SVGProps } from 'react'

import './index.less'

interface IconButtonProps {
  onClick?: () => void
  icon?: FC<SVGProps<SVGSVGElement>>
  isActive?: boolean
  className?: string
}

export const IconButton = ({ onClick, icon, isActive, className }: IconButtonProps) => {
  return (
    <div className={`iconButton ${isActive ? 'active' : ''} ${className ? className : ''}`} onClick={() => (onClick ? onClick() : undefined)}>
      <Icon component={icon} />
    </div>
  )
}
